'use client';

import React from 'react';

interface IStep {
    render(props: IStep): void;
    isActive?: boolean;
    currentStep?: number;
    onPrevStep?(): void;
    onNextStep?(): void;
    navigateTo?(step: number): void;
}

export const Step: React.FC<IStep> = (props) => {
    if (!props.isActive) {
        return null;
    }

    return <>{props.render(props)}</>;
};
